module.exports = __webpack_public_path__ + "img/help_act.4940d655.svg";